<template>
<CModal @mtdclosemodal="mtdclosemodal" :show="boo_modal" :close-on-backdrop="false" :centered="true" :title="title" :size="'lg'" :btn_cancel="true" :btn_ok="true" :booTitile="true">
    <div  class="row mx-0  px-2">
        <div class="row mx-0 px-0" v-if="data.length > 0">
            <div class="col-xl-3 mb-1  px-1 " v-for="(item,index) in data" :key="index">
                <div class="text-center  text-white rounded rounded-2 btn-asistencial text-xxs h-100 border border-main border-3">
                    <button @click="addbed (item.id)" type="button" class="btn w-100 text-xs h-100 ">
                        {{ item.name}} 
                    </button>
                </div>
            </div>
        </div>
        <div class="text-center fw-bold" v-else>
            <span>No hay registros</span>
        </div>
    </div>
    
    <template #footer>
        <!-- <button @click="mtdclosemodal" class="btn btn-danger btn-sm">
            <i class="fa fa-times" />&nbsp;Cerrar
        </button>
        <button class="btn btn-success btn-sm">
            Guardar
        </button>
        &nbsp; -->
    </template>
    <SweetAlert :swal="swal" ref="SweetAlert" />
</CModal>
</template>

<script>
import CModal from "@/components/shared/modals/CModal.vue";
import SweetAlert from '@/components/shared/SweetAlert/SweetAlert.vue';
import {
    mapActions
} from "vuex";

export default {
    name: "c-medico-modal-diagnostico",

    data() {
        return {
            swal: null,
            data: [],
           
        }
    },
    components: {
        CModal,
        SweetAlert
    },
    
    props: {
        title: String,
        boo_modal: Boolean,
        bed: {
            type: Object,
            default: () => ({})
        },

    },
    watch: {
        bed: {
            handler(newVal) {
                if (Object.keys(newVal).length > 0) {
                  this.mtdcamasHosp(newVal.campu_id)
                }

            },
            immediate: true
        }
    },
    methods: {
        ...mapActions(["get", "post"]),
        mtdclosemodal() {
            this.$emit('mtdclosemodalBed')
        },
        mtdcamasHosp: function (campu_id) {
            this.get({
                url: this.$store.getters.get__url + "/admision/freebedshosp/" + campu_id,
                token: this.$store.getters.get__token,

            }).then((response) => {
                this.data = response.data
           
            });

        },
        addbed:function(bedaux){
           this.$emit('addbedAux', bedaux, this.bed )
        }
       
       
        

    },
}
</script>
